import React, { Component } from 'react';
import { connect } from "react-redux";
import { openPullout, setSidebar } from "../../Actions/endUserActions"

import axios from "axios";
import moment from "moment";
import { Trans } from 'react-i18next';

class EUSidebarMediaCard extends Component {
    constructor(props) {
        super(props);

        this.toggleOptions = this.toggleOptions.bind(this);
        this.addMedia = this.addMedia.bind(this);
        this.setReminder = this.setReminder.bind(this);
        this.dismiss = this.dismiss.bind(this);

        this.state = {
            media_options: false,
            pullout: true
        };
    }

    componentDidMount() {
    }

    toggleOptions() {
        this.setState({
            media_options: !this.state.media_options
        })
    }

    addMedia() {
        this.setState({
            media_options: false,
            pullout: false
        })
        this.props.history.push(this.props.match.url + '/media/' + this.props.booking.BOOK_ID + '/create');
    }

    setReminder() {
        this.setState({
            media_options: false,
            pullout: false
        })
        this.props.history.push(this.props.match.url + '/media_reminder/' + this.props.booking.BOOK_ID);
    }

    dismiss() {
        var self = this;
        axios.get('/ajax/media_reminders/dismissUser/' +  this.props.booking.BOOK_ID)
        .then(function(response) {
            axios.get('/ajax/eu-home/sidebar')
            .then(function(response) {
                self.setState({
                    media_options: false,
                    pullout: false
                })
                self.props.dispatch(setSidebar(response))
            })

            showStatusMsg(response?.data.message, 'success')
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    render() {
        return (
            <div className="eu-sidebar-booking-card">
            <div className="eu-sidebar-booking-card-left">
                <h2>{this.props.booking.vehicle.Year} {this.props.booking.vehicle.Make} {this.props.booking.vehicle.Model} {this.props.booking.vehicle.Trim}</h2>
                <div className="eu-sidebar-booking-card-dates">
                    <div className="eu-sidebar-booking-card-dates-pickup">
                        <p className = 'eu-sidebar-booking-card-dates-date'>{moment(this.props.booking.Start_Date).format('MMM DD, YYYY')}</p>
                        <p className = 'eu-sidebar-booking-card-dates-time'>{moment(this.props.booking.Release_Time, "HH:mm:ss").format("h:mm A")}</p>
                    </div>
                    <div className="eu-sidebar-booking-card-dates-arrow">
                        <i className="fas fa-long-arrow-alt-right"></i>
                    </div>
                    <div className="eu-sidebar-booking-card-dates-dropoff">
                        <p className = 'eu-sidebar-booking-card-dates-date'>{moment(this.props.booking.End_Date).format('MMM DD, YYYY')}</p>
                        <p className = 'eu-sidebar-booking-card-dates-time'>{moment(this.props.booking.Return_Time, "HH:mm:ss").format("h:mm A")}</p>
                    </div>
                </div>
            </div>
            <div className="eu-sidebar-booking-card-right" onClick={this.toggleOptions}>
                <i className="fas fa-ellipsis-v black-lighter"></i>
            </div>
            {
                this.props.first && this.props.booking["media_reminder"] === null && this.state.pullout ?
                    <div className="eumedia-pane dropdown-pane float-right p-16 is-open" id = "media-1-pop" data-alignment="center" style={{position: "absolute",width:"330px",left:'270px'}}>
                        <span><Trans>Hope your booking was productive and valuable. Please add your media if it has been published.</Trans></span>
                        <div className="button-group mt-16">
                            <div className="button primary mr-8" onClick={this.addMedia}>
                                <Trans>Add Now</Trans>
                            </div>
                            <div className="button mr-8" onClick={this.setReminder}>
                                <Trans>Add Later</Trans>
                            </div>
                            <div className="button" onClick={this.dismiss}>
                                <Trans>Dismiss</Trans>
                            </div>
                        </div>
                    </div>
                :
                    null
            }
            {
                this.state.media_options ?
                    <div className="card eu-sidebar-booking-card-mediadropdown">
                        <ul>
                            <li><a onClick={this.addMedia}><Trans>Add Media</Trans></a></li>
                            <li><a onClick={this.setReminder}><Trans>Add Reminder</Trans></a></li>
                            <li><a onClick={this.dismiss}><Trans>Dismiss</Trans></a></li>
                        </ul>
                    </div>
                :
                    null
            }
        </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser
});

export default connect(mapStateToProps)(EUSidebarMediaCard);